import type { ReactNode } from 'react';

export type TrainingStepState = 'LOCKED' | 'CURRENT' | 'COMPLETED';

export interface TrainingStepperStep {
  key: string;
  title: string;
  content: ReactNode;
}

function stateFor(key: string, completedKeys: string[], currentKey: string | null): TrainingStepState {
  if (completedKeys.includes(key)) return 'COMPLETED';
  if (key === currentKey) return 'CURRENT';
  return 'LOCKED';
}

const STATE_LABEL: Record<TrainingStepState, string> = { COMPLETED: 'Completed', CURRENT: 'Current step', LOCKED: 'Locked' };

export function TrainingStepper({ steps, completedKeys, currentKey }: { steps: TrainingStepperStep[]; completedKeys: string[]; currentKey: string | null }) {
  return (
    <ol className="training-stepper">
      {steps.map((step) => {
        const state = stateFor(step.key, completedKeys, currentKey);
        return (
          <li key={step.key} className={`training-stepper-step ${state.toLowerCase()}`} aria-current={state === 'CURRENT' ? 'step' : undefined}>
            <div className="training-stepper-marker" aria-hidden="true">
              {state === 'COMPLETED' ? <span className="training-stepper-check">✓</span> : <span className="training-stepper-circle" />}
            </div>
            <div className="training-stepper-body">
              <h2 className="training-stepper-title">
                {step.title}
                <span className="sr-only"> ({STATE_LABEL[state]})</span>
              </h2>
              {state === 'LOCKED'
                ? <p className="training-stepper-locked-note">Complete the previous step to unlock this one.</p>
                : <div className="training-stepper-content">{step.content}</div>}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
